import src from "IMAGE";
export default { src, width: 750, height: 180, blurWidth: 0, blurHeight: 0};
